import { Route, Redirect } from "react-router";
import can from "lib/permissions/can";
import { useAuth } from "components/common/AuthProvider";

export default ({
  currentUser: standardUser,
  permission,
  redirectTo,
  component: Component,
  layout: Layout,
  location,
  ...rest
}) => {
  const { user: anonymousUser } = useAuth();
  
  return (
    <Route
      {...rest}
      render={props => {
        const pathname = redirectTo || "/signin";
        const search = `?url=${encodeURIComponent(`${props.location.pathname}${props.location.search}`)}`;
        const hasPermission = permission === undefined || can(standardUser)(permission);

        // No user exists
        if (!standardUser && !anonymousUser) {
          return <Redirect to={{ pathname, search }} />
        }

        // standard user exists but does not have permission
        if (standardUser && !hasPermission) {
          return <Redirect to={{ pathname: "/not-found", search }} />
        }

        if (!standardUser && !location.pathname.startsWith('/referral')) {
          return <Redirect to={{ pathname, search }} />
        }

        return Layout === undefined ? (
          <Component {...props} />
        ) : (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }
    }
    />
  )
};